export default "__VITE_ASSET__DtIpLDLv__"